const Loading = () => (
  <div className='loading'>
    Loading...
  </div>
);

export default Loading;
